import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AuthGuard from './components/Guards/GuardAuth';
import Error404 from './components/Layout/404/404';
import Home from './components/Layout/Home/Home';
import AppsList from './components/Layout/Apps/AppsList';
import AppDetail from './components/Layout/Apps/AppDetail';
import AppPrivacy from './components/Layout/Apps/AppPrivacy';
import AppTerms from './components/Layout/Apps/AppTerms';
import AppContrata from './components/Layout/Apps/AppContrata';
import ScrollManager from './components/Modules/ScrollManager';

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/apps" element={<AppsList />} />
        <Route path="/apps/:appId" element={<AppDetail />} />
        <Route path="/apps/:appId/privacidad" element={<AppPrivacy />} />
        <Route path="/apps/:appId/privacy" element={<AppPrivacy />} />
        <Route path="/apps/:appId/terminos" element={<AppTerms />} />
        <Route path="/apps/:appId/terms" element={<AppTerms />} />
        <Route path="/apps/:appId/contrata" element={<AppContrata />} />
        <Route path="/apps/:appId/subscribe" element={<AppContrata />} />
        <Route
          path="/panel"
          element={
            <AuthGuard>
              {/* TODO: reemplaza esto por tu componente del panel privado */}
              <div>Panel</div>
            </AuthGuard>
          }
        />
        <Route path="*" element={<Error404 />} />
      </Routes>
      <ScrollManager />
    </BrowserRouter>
  );
};

export default Router;
